import { Spinner, SpinnerSize, Stack } from '@fluentui/react'

type LoadingSpinnerProps = {
  label?: string
}

const LoadingSpinner = ({ label = 'Loading...' }: LoadingSpinnerProps) => {
  return (
    <Stack horizontalAlign="center" verticalAlign="center" styles={{ root: { padding: 40 } }}>
      <Spinner size={SpinnerSize.large} label={label} />
    </Stack>
  )
}

export default LoadingSpinner
